import { Box, Typography } from "@mui/material";
import Link from "next/link";
import React, { FC } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import { strings } from "@/src/shared/strings";
import { PdfCellProps } from "../lib/type";

export const PdfLinkCell: FC<PdfCellProps> = ({
  iconName,
  iconText = strings.proposalTable.getToKnowDetailProgram,
  url
}) => {
  return (
    <Link href={url || "/"} className="flex items-center gap-4" target={"_blank"} rel="noopener noreferrer">
      <Box className="h-12 w-9 max-mdPlus:h-9 max-mdPlus:w-7">
        <WebShopIcon
          name={iconName}
          className="h-12 w-9 stroke-blue max-mdPlus:h-9 max-mdPlus:w-7"
        />
      </Box>
      <Typography className="text-[15px] font-normal text-blue underline">
        {iconText}
      </Typography>
    </Link>
  );
};
